import { connect } from "react-redux";
import SurveyStepEmplacement from "./SurveyStepEmplacement";
import { getKpiList } from "./../../../../redux/actions/surveyActions";
import {
	storeSurveyProgress,
	getLocation,
	reset,
	addStepSurvey,
} from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		//currentSurvey: surveySelector(state, ownProps),
		surveyProgress: state.survey.surveyManager.surveyProgress,
		//locatonList: state.survey.surveyManager.locatonList,
		locatonList: state.survey.surveyManager.surveyProgress.model[0].locationsStructure || [],
		model: state.survey.surveyManager.surveyProgress.model,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		resetSimulation: survey => {
			dispatch(reset(survey));
		},
		getKpiList: () => {
			dispatch(getKpiList());
		},
		getLocation: (idClient, idRetailer) => {
			dispatch(getLocation(idClient, idRetailer));
		},
		storeSurveyProgress: () => {
			dispatch(storeSurveyProgress());
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SurveyStepEmplacement);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepEmplacement/SurveyStepEmplacementContainer.js